import React from 'react';
import {Link} from 'react-router-dom'

const Footer = () => {
  return (
    <footer className="bg-blue-950 text-white py-6">
      <div className="max-w-7xl flex items-center justify-center  mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-1 grid-cols-3 md:grid-cols-5 md:gap-[70px]">
          <div>
            <h1 className="text-xl font-bold">About</h1>
            <ul className='mt-4 text-[12px] md:text-[16px]'>
              <li className='mt-2'>Value</li>
              <li className='mt-2'>Leadership</li>
            </ul>
          </div>
          <div>
            <h1 className="text-xl font-bold ">Events</h1>
            <ul className='mt-4 text-[12px] md:text-[16px]'>
              <li>Breakfast with <br/>HolySpirit</li>
              <li className='mt-2'>Bible Study</li>
              <li className='mt-2'>Sunday Service</li>
              <li className='mt-2'>others</li>
            </ul>
          </div>
          <div>
            <h1 className="text-xl font-bold ">Media</h1>
            <ul className='mt-4 text-[12px] md:text-[16px]'>
              <li>Sermon</li>
              <li className='mt-2'>Watch online</li>
              <li className='mt-2'>Points Images</li>
              <li className='mt-2'>Studio team</li>
            </ul>
          </div>
          <div className=''>
            <h1 className="text-xl font-bold ">Join us</h1>
            <ul className='mt-4 text-[16px]'>
              <li className='mt-2'>Contact Us</li>
              <li className='mt-2'>Find Location</li>
            </ul>
          </div>
          <div className=''>
            <h1 className="text-xl font-bold ">Finance</h1>
            <ul className='mt-4 text-[16px]'>
              <li className='mt-2'>Online Giving</li>
              <Link to='/login'>
                <li className='mt-2' >Admin</li>
              </Link>
              <Link to={'/promologin'}>
                <li className="mt-2">Gifting</li>
              </Link>

            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
